import { store } from "../redux";
import { logoutUser } from "../redux/reducers/user-authentication/authentication-action";
import { isAuthenticated } from "../lib/api/tokenStore";

export const CUSTOM_ERROR_CODES = [401, 409];

/**
 * At most one logout per page life.
 *
 * Every failing request used to start its own, and the redirect target
 * reloaded the app with the tokens still in storage, so the boot request
 * failed the same way and bounced again. That was the reload loop.
 */
let loggingOut = false;

const handleRedirection = () => {
  window.location.replace("/");
};

/**
 * The terminal end of a dead session: drop the tokens FIRST, then leave.
 * `logoutUser` clears the token store, so the reloaded app comes up signed
 * out and has nothing left to 401 on.
 */
export const forceLogout = () => {
  if (loggingOut) return;
  loggingOut = true;

  store.dispatch(logoutUser(handleRedirection));
};

// Handle Unauthorized Error - 401
export const handleUnauthorized = (error) => {
  // Reached only once the refresh in `utils/axios` has already failed, so the
  // session is genuinely dead. A 401 with no session at all is a public route
  // answering — there is nothing to end.
  if (isAuthenticated()) forceLogout();

  return Promise.reject(error);
};

// Handle DB Conflict Error - 409
export const handleDBConflict = () => {
  return Promise.reject("conflict.error");
};
